import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_LAYERS: GlameraIconDefinition = {
  name: 'layers',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-layers-top" d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"></path>
    <path class="glm-layers-bottom" d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"></path>
    <path class="glm-layers-middle" d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-layers-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './layers.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class LayersIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_LAYERS;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
